'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

export default function GlobalError({ error, reset }: any) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <main
          style={{
            minHeight: '100vh',
            display: 'grid',
            placeItems: 'center',
            padding: 24,
            fontFamily: 'Inter, Arial, sans-serif',
            textAlign: 'center',
          }}
        >
          <div>
            <p style={{ color: '#ff0a12', fontWeight: 800 }}>LUCASART</p>
            <h1 style={{ margin: '8px 0 12px' }}>Niečo sa nepodarilo</h1>
            <p style={{ color: '#707075' }}>Stránku môžete bezpečne načítať znova.</p>
            <button
              type="button"
              onClick={reset}
              style={{
                marginTop: 16,
                border: 0,
                padding: '12px 20px',
                background: '#ff0a12',
                color: '#fff',
                fontWeight: 800,
                cursor: 'pointer',
              }}
            >
              Skúsiť znova
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
